NtechApp.BaseDashboardCover = function($view, routes) {
    var me = this;

    this._$view = null;
    this._routes = null;

    this._dom = null;
    this._ajax = null;
    this._click = null;

    this._loader = null;
    this._overlay = null;

    this._$item = null;
    this._imageType = null;

    this._construct = function() {
        me._$view = $view;
        me._routes = routes;

        me._dom = new NtechApp.Dom();
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._loader = new NtechApp.Loader();
        me._overlay = new NtechApp.Overlay();

        me._createUploader(me._$view.find('[data-imageuploader="cover"]'), function(data) {
            me._$view.find(".cover").css("backgroundImage", "url('" + data.url + "')");
            me._$view.find(".coverControls .deleteControl").removeClass("disabledControl");
            me._$view.find("[data-coverPhotoMenu]").css("display", "none");

            NtechApp.info.on("Cover uploaded succesfully.");
        }, me._routes.saveCoverRoute);
        me._createUploader(me._$view.find('[data-imageuploader="avatar"]'), function(data) {
            $("body").find("[data-updateAvatarImg]").attr("src", data.url);
            me._$view.find(".avatarControls .deleteControl").removeClass("disabledControl");
            me._$view.find("[data-avatarPhotoMenu]").css("display", "none");

            NtechApp.info.on("Avatar uploaded successfully.");
        }, me._routes.saveAvatarRoute);

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view, "[data-coverPhotoMenuTrigger]", function() {
            me._$view.find("[data-coverPhotoMenu]").css("display", "block");
        });

        me._click.listen(me._$view, "[data-closeCoverPhotoMenu]", function() {
            me._$view.find("[data-coverPhotoMenu]").css("display", "none");
        });

        me._click.listen(me._$view, "[data-avatarPhotoMenuTrigger]", function() {
            me._$view.find("[data-avatarPhotoMenu]").css("display", "block");
        });

        me._click.listen(me._$view, "[data-closeAvatarPhotoMenu]", function() {
            me._$view.find("[data-avatarPhotoMenu]").css("display", "none");
        });

        me._click.listen(me._$view, "[data-imageuploaderTrigger='cover']", function(event) {
            me._$view.find("[data-imageuploader='cover']").find(":file").trigger("click");
        });
        me._click.listen(me._$view, "[data-imageuploaderTrigger='avatar']", function(event) {
            me._$view.find("[data-imageuploader='avatar']").find(":file").trigger("click");
        });

        me._click.listen(me._$view, ".coverControls .deleteControl", function(event) {
            me._rmCover($(event.target).closest(".deleteControl"));
        });
        me._click.listen(me._$view, ".avatarControls .deleteControl", function(event) {
            me._rmAvatar($(event.target).closest(".deleteControl"));
        });

        NtechApp.uploader.cancelBodyDrops();
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.BaseDashboardCover, {
    _enableLoader: function() {
        this._overlay.on();
        this._loader.on();
    },

    _disableLoader: function() {
        this._overlay.off();
        this._loader.off();
    },

    _createUploader: function($uploader, cb, saveRoute) {
        var me = this;

        this._$view.find($uploader).find(":file").fileupload({
            dropZone: $uploader,
            dataType: 'json',
            formData: {
                uploadType: $uploader.attr("data-uploadType")
            },
            add: function(e, data) {
                $.each(data.files, function(index, file) {
                    if(!NtechApp.uploader.hasFileValidSize(file))
                        return;
                    // For testing
                    // $('body').append('<img src="' + URL.createObjectURL(data.files[0]) + '" style="max-width: 100%"/>');

                    me._enableLoader();
                    data.context = me._$item;
                    data.submit();
                });
            },
            done: function (e, data) {
                $.each(data.result, function(i, fileData) {
                    if(fileData.error) {
                        NtechApp.info.on(fileData.errorMsg, 3000);
                        me._disableLoader();
                    }
                    else
                        me._finishUpload(data, fileData, cb, saveRoute);
                });
            }
        });
    },

    _finishUpload: function(data, fileData, cb, saveRoute) {
        var me = this;

        this._ajax.post({
            url: Routing.generate(saveRoute),
            data: {
                image: fileData.filename
            },
            onSuccess: function(res) {
                cb(res);
            },
            onComplete: function() {
                me._disableLoader();
            }
        });
    },

    _rmCover: function($button) {
        if($button.hasClass("disabledControl")) {
            NtechApp.info.on("Please upload cover first.");
            return;
        }

        var me = this;
        NtechApp.confirmForm.load(function() {
            me._ajax.post({
                url: Routing.generate(me._routes.rmCoverRoute),
                onSuccess: function(res) {
                    me._$view.find(".cover").css("background-image", "url('" + res.url + "')");
                    $button.addClass("disabledControl");

                    NtechApp.confirmForm.unload();
                },
                onComplete: function() {
                    me._disableLoader();
                }
            });
        });
    },

    _rmAvatar: function($button) {
        if($button.hasClass("disabledControl")) {
            NtechApp.info.on("Please upload avatar first.");
            return;
        }

        var me = this;
        NtechApp.confirmForm.load(function() {
            me._ajax.post({
                url: Routing.generate(me._routes.rmAvatarRoute),
                onSuccess: function(res) {
                    $("body").find("[data-updateAvatarImg]").attr("src", res.url);
                    $button.addClass("disabledControl");

                    NtechApp.confirmForm.unload();
                },
                onComplete: function() {
                    me._disableLoader();
                }
            });
        });
    }
});